<app-configuration-menu></app-configuration-menu>

<router-outlet></router-outlet>
